export default __webpack_public_path__ + "static/media/dashboard_prototypes.b140d883.jpg";